var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7451 16.0417H6.26591C5.50077 16.0417 4.88049 16.662 4.88049 17.4272V17.573C4.88049 18.3381 5.50077 18.9584 6.26591 18.9584H29.7451C30.5102 18.9584 31.1305 18.3381 31.1305 17.573V17.4272C31.1305 16.662 30.5102 16.0417 29.7451 16.0417Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7451 23.3333H6.26591C5.50077 23.3333 4.88049 23.9535 4.88049 24.7187V24.8645C4.88049 25.6296 5.50077 26.2499 6.26591 26.2499H29.7451C30.5102 26.2499 31.1305 25.6296 31.1305 24.8645V24.7187C31.1305 23.9535 30.5102 23.3333 29.7451 23.3333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7451 8.75H6.26591C5.50077 8.75 4.88049 9.37027 4.88049 10.1354V10.2813C4.88049 11.0464 5.50077 11.6667 6.26591 11.6667H29.7451C30.5102 11.6667 31.1305 11.0464 31.1305 10.2813V10.1354C31.1305 9.37027 30.5102 8.75 29.7451 8.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.e5a6947231744147933547af35d30d9a.svg";
export { ForwardRef as ReactComponent };